import type { FC } from "react";

import { UpgradeLink } from "app/components/React/Table/cells/UpgradeLink";
import type { IUrlCellProps } from "app/components/React/Table/cells/UrlCell";
import { UrlCell } from "app/components/React/Table/cells/UrlCell";

export interface IKeyValuePair {
    Key: string;
    Value: string;
}

interface IUrlCellWebsiteAnalysisProps extends Partial<IUrlCellProps> {
    value: string | IKeyValuePair[];
}

// the UrlCell implements adapter design pattern for each type of input value.
export const UrlCellWebsiteAnalysis: FC<IUrlCellWebsiteAnalysisProps> = ({ value = "", ...rest }) => {
    const isValueArray = Array.isArray(value);

    if (!isValueArray) {
        if (value === "grid.upgrade") {
            return <UpgradeLink hookType="pages" />;
        }
        return (
            <UrlCell
                site={value}
                {...rest}
            />
        );
    }

    return (
        <UrlCell
            site={value[0].Value}
            tooltipData={value.length > 1 ? value : undefined}
            {...rest}
        />
    );
};
